import { STATUS_CODES } from "../constants/StatusCodes";

export function isForbiddenError(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "status" in error &&
    error.status === STATUS_CODES.FORBIDDEN
  );
}
